import { Component, OnInit } from '@angular/core';
import { RestApiServices } from '../providers/rest.service';
import { LanguageService } from '../providers/lang.service';
import { CustomStorage } from '../providers/Custom-storage.service';
import { Observable, Subject } from 'rxjs';
import { SharedServiceService } from '../shared/shared-service.service';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { OnDestroy, AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
// import { DashboardComponent } from '../dashboard/dashboard.component';
import { LoaderComponent } from '../loader/loader.component';

@Component({
  selector: 'searchproduct',
  templateUrl: './searchlist.component.html',
  styleUrls: ['./searchlist.component.css']
})
export class SearchlistComponent implements OnInit, OnDestroy, AfterViewInit {
  //showloading: boolean = false;
  public active: boolean = false 
  uom: string = ""
  term: any;
  item: string = ""
  stock: string = ""
  input: any;
  public flag: boolean = false;
  public searchTerms = new Subject<string>();
  public clients: any;
  public ClientName = '';
  searchDetails = [];
  search_label:any = 'Search Results';
  search_result:any = 'Results';
  searchCount : number = 0;unit_size: string = "";unit_color: string = "";
  search_key : string = '';addto_cart: string = "";  Lbl_check_quantity : string = "";
  item_number: string = "";
  selcet_color: string = "";selcet_size: string = "";quantity_txt: string = "";left_instock: string = "";
  yes: string = "";no: string = "";cartMsg1: string = ""; cartMsg2: string = "";cartMsg3: string = "";
  isInvoiceDataInit:boolean=false;result_notfound: string="";in_cart: string = "";lbl_uom : string = "";lbl_qty : string = "";
  private subscription: Subscription = new Subscription();

  constructor(private restApi: RestApiServices, public router: Router,
    private langService: LanguageService, private localstorage: CustomStorage, 
    private sharedService:SharedServiceService) { }

    ngAfterViewInit(){  
      
      this.sharedService.changeFilter(false);

      this.langService.getJson().subscribe(data => {
        this.setLabels();
      });
      
      this.sharedService.changeFooterSelected('shop');

      this.sharedService.changeProductsSearchStatus(true);
      this.sharedService.changeBackbuttonStatus(true);
  
      this.subscription.add(
        this.restApi.selectedsearchItem.subscribe(data => {
         
          this.search_key = data;
          this.searchDetails = [];
          if(this.search_key != ''){
            //this.showloading = true;
            //this.sharedService.setLoadingFlag(true);
            LoaderComponent.loadingV.next(true);
            this.restApi.getAllSearchProducts(data).subscribe(res => {
              if(res !== undefined){
                //this.showloading = false;
                //this.sharedService.setLoadingFlag(false);
                LoaderComponent.loadingV.next(false);
                this.searchDetails = res;
                this.isInvoiceDataInit =  true
                this.searchCount = this. searchDetails.length;
                this.sharedService.setCategoryDetails(this.search_label, this.searchCount);
              }
            }, error => {
              LoaderComponent.loadingV.next(false);
              this.errorDialog = true;
              this.searchDetails = [];
              this.isInvoiceDataInit= true
              this.errorData = error;
              console.log(error);
            });
          }else{
            this.localstorage.getItem('searchKey').subscribe(key => {
              
              if(key != null){
                this.search_key = key;
              }
            });
            
            this.localstorage.getItem('searchResults').subscribe(res => {              
              if(res != null)
                this.searchDetails = res;
                this.isInvoiceDataInit =  true
            });
          }
        })
      );
    }

    errorDialog :boolean = false;
    errorData : any; 

  ngOnInit() {
    
  }
  
  itemSelected(product){
    this.localstorage.setItem('productSelected', product).subscribe(res => {
      this.router.navigate(['/productdetails']);
    });
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }
  //Toggle category for Mobile View 
 hideCategoryMobileView($event) {
  this.active = !this.active;
}
setLabels() {
 
  this.langService.getLangLabelValue("LblInStock").then(result => {
    this.stock = result;
  });
  
  this.langService.getLangLabelValue("LblItem").then(result => {
    this.item_number = result;
  });
  this.langService.getLangLabelValue("LblAddToCart").then(res => {
    this.addto_cart = res;
  });
  this.langService.getLangLabelValue("LblSelectColor").then(result => {
    this.selcet_color = result;
  });
  this.langService.getLangLabelValue("LblselectSize").then(result => {
    this.selcet_size = result;
  });
  this.langService.getLangLabelValue("LblenterQuantityHere").then(result => {
    this.quantity_txt = result;
  });
  this.langService.getLangLabelValue("LblYes").then(result => {
    this.yes = result;
  });
  this.langService.getLangLabelValue("LblNo").then(result => {
    this.no = result;
  });
  this.langService.getLangLabelValue("200_not_enough_qty_cart1").then(result => {
    this.cartMsg1 = result;
  });
  this.langService.getLangLabelValue("200_not_enough_qty_cart2").then(result => {
    this.cartMsg2 = result;
  });
  this.langService.getLangLabelValue("200_not_enough_qty_cart3").then(result => {
    this.cartMsg3 = result;
  });
  this.langService.getLangLabelValue("LblCheckQuantity").then(result => {
    this.Lbl_check_quantity = result;
    
  });
  this.langService.getLangLabelValue("LblColor").then(result => {
    this.unit_color = result;
  });
  this.langService.getLangLabelValue("LblSize").then(result => {
    this.unit_size = result;
  });
  this.langService.getLangLabelValue("LblLeftInStock").then(result => {
    this.left_instock = result;
    
  });
  this.langService.getLangLabelValue("200_no_data_found").then(res => {
    this.result_notfound = res
    
  });
  this.langService.getLangLabelValue("LblInCart").then(result => {
    this.in_cart = result;  
  }); 
  this.langService.getLangLabelValue("LblItemUOM").then(result => {
    this.lbl_uom = result;  
  });
  this.langService.getLangLabelValue("LblUOMQty").then(result => {
    this.lbl_qty = result;  
  });
  this.sharedService.setCategoryDetails(this.search_label, 0);
}

}



// WEBPACK FOOTER //
// ./src/app/searchlist/searchlist.component.ts